/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/shared/pager/eva-pager.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import10 from '@angular/core/src/linker/view_container';
import * as import11 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import12 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from '@angular/common/src/directives/ng_class';
import * as import15 from '../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import16 from '@angular/core/src/linker/template_ref';
import * as import17 from '@angular/common/src/directives/ng_for';
export class Wrapper_EvaPagerComponent {
  /*private*/ _eventHandler:Function;
  context:import0.EvaPagerComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  subscription0:any;
  constructor() {
    this._changed = false;
    this.context = new import0.EvaPagerComponent();
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_config(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.config = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.pageChanged.subscribe(_eventHandler.bind(view,'pageChanged'))); }
  }
}
var renderType_EvaPagerComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_EvaPagerComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.EvaPagerComponent>;
  _EvaPagerComponent_0_3:Wrapper_EvaPagerComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_EvaPagerComponent_Host0,renderType_EvaPagerComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'eva-pager',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_EvaPagerComponent0(this.viewUtils,this,0,this._el_0);
    this._EvaPagerComponent_0_3 = new Wrapper_EvaPagerComponent();
    this.compView_0.create(this._EvaPagerComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._EvaPagerComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.EvaPagerComponent) && (0 === requestNodeIndex))) { return this._EvaPagerComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._EvaPagerComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._EvaPagerComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const EvaPagerComponentNgFactory:import8.ComponentFactory<import0.EvaPagerComponent> = new import8.ComponentFactory<import0.EvaPagerComponent>('eva-pager',View_EvaPagerComponent_Host0,import0.EvaPagerComponent);
const styles_EvaPagerComponent:any[] = ([] as any[]);
class View_EvaPagerComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgClass_2_3:import9.Wrapper_NgClass;
  _text_3:any;
  _map_5:any;
  /*private*/ _expr_6:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_EvaPagerComponent1,renderType_EvaPagerComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_5 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-active': p0};
    });
    this._expr_6 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class','pagination-item-container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'a',new import3.InlineArray2(2,'class','pagination-item eva-3-link'),(null as any));
    this._NgClass_2_3 = new import9.Wrapper_NgClass(this.parentView.parentView.injectorGet(import11.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import12.KeyValueDiffers,this.parentView.parentIndex),new import13.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._NgClass_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = 'pagination-item eva-3-link';
    this._NgClass_2_3.check_klass(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this._map_5((this.context.$implicit == this.parentView.context.config.currentPage));
    this._NgClass_2_3.check_ngClass(currVal_2_0_1,throwOnChange,false);
    this._NgClass_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_6:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_6,currVal_6)) {
      this.renderer.setText(this._text_3,currVal_6);
      this._expr_6 = currVal_6;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.goTo(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_EvaPagerComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_EvaPagerComponent,{});
export class View_EvaPagerComponent0 extends import2.AppView<import0.EvaPagerComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _el_5:any;
  _NgClass_5_3:import9.Wrapper_NgClass;
  _el_6:any;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _vc_8:import10.ViewContainer;
  _TemplateRef_8_5:any;
  _NgFor_8_6:import15.Wrapper_NgFor;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _NgClass_12_3:import9.Wrapper_NgClass;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _map_24:any;
  _map_25:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_EvaPagerComponent0,renderType_EvaPagerComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._map_24 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-disable': p0};
    });
    this._map_25 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-disable': p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','reset-styles eva-3-pagination'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'ul',new import3.InlineArray2(2,'class','pagination-container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'li',new import3.InlineArray2(2,'class','pagination-item-container page-prev'),(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_4,'a',new import3.InlineArray4(4,'class','pagination-item eva-3-link','title','Previous'),(null as any));
    this._NgClass_5_3 = new import9.Wrapper_NgClass(this.parentView.injectorGet(import11.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import12.KeyValueDiffers,this.parentIndex),new import13.ElementRef(this._el_5),this.renderer);
    this._el_6 = import3.createRenderElement(this.renderer,this._el_5,'i',new import3.InlineArray2(2,'class','eva-3-icon-arrow-left pagination-icon'),(null as any));
    this._text_7 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_8 = new import10.ViewContainer(8,2,this,this._anchor_8);
    this._TemplateRef_8_5 = new import16.TemplateRef_(this,8,this._anchor_8);
    this._NgFor_8_6 = new import15.Wrapper_NgFor(this._vc_8.vcRef,this._TemplateRef_8_5,this.parentView.injectorGet(import11.IterableDiffers,this.parentIndex),this.ref);
    this._text_9 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_2,'li',new import3.InlineArray2(2,'class','pagination-item-container page-next'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'a',new import3.InlineArray4(4,'class','pagination-item eva-3-link','title','Next'),(null as any));
    this._NgClass_12_3 = new import9.Wrapper_NgClass(this.parentView.injectorGet(import11.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import12.KeyValueDiffers,this.parentIndex),new import13.ElementRef(this._el_12),this.renderer);
    this._text_13 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'i',new import3.InlineArray2(2,'class','eva-3-icon-arrow-right pagination-icon'),(null as any));
    this._text_15 = this.renderer.createText(this._el_12,'\n            ',(null as any));
    this._text_16 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_18 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_5,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_5));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_12,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_12));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._el_5,
      this._el_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._text_18
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.NgClass) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgClass_5_3.context; }
    if (((token === import16.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import17.NgFor) && (8 === requestNodeIndex))) { return this._NgFor_8_6.context; }
    if (((token === import14.NgClass) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 15)))) { return this._NgClass_12_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_5_0_0:any = 'pagination-item eva-3-link';
    this._NgClass_5_3.check_klass(currVal_5_0_0,throwOnChange,false);
    const currVal_5_0_1:any = this._map_24((((this.context.config == null)? (null as any): this.context.config.currentPage) == 1));
    this._NgClass_5_3.check_ngClass(currVal_5_0_1,throwOnChange,false);
    this._NgClass_5_3.ngDoCheck(this,this._el_5,throwOnChange);
    const currVal_8_0_0:any = this.context.getActualPages();
    this._NgFor_8_6.check_ngForOf(currVal_8_0_0,throwOnChange,false);
    this._NgFor_8_6.ngDoCheck(this,this._anchor_8,throwOnChange);
    const currVal_12_0_0:any = 'pagination-item eva-3-link';
    this._NgClass_12_3.check_klass(currVal_12_0_0,throwOnChange,false);
    const currVal_12_0_1:any = this._map_25((((this.context.config == null)? (null as any): this.context.config.currentPage) === ((this.context.config == null)? (null as any): this.context.config.numPages)));
    this._NgClass_12_3.check_ngClass(currVal_12_0_1,throwOnChange,false);
    this._NgClass_12_3.ngDoCheck(this,this._el_12,throwOnChange);
    this._vc_8.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_8.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 8)) { return new View_EvaPagerComponent1(this.viewUtils,this,8,this._anchor_8,this._vc_8); }
    return (null as any);
  }
  handleEvent_5(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.previous()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_12(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.next()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/shared/pager/eva-pager.component.ngfactory.ts